//#region src/lib/safeStorage.ts
const memory = /* @__PURE__ */ new Map();
const safeStorage = typeof window !== "undefined" && window.localStorage ? window.localStorage : {
	get length() {
		return memory.size;
	},
	clear() {
		memory.clear();
	},
	getItem(key) {
		return memory.has(key) ? memory.get(key) : null;
	},
	key(index) {
		return Array.from(memory.keys())[index] ?? null;
	},
	removeItem(key) {
		memory.delete(key);
	},
	setItem(key, value) {
		memory.set(key, String(value));
	}
};

//#endregion
export { safeStorage };
//# sourceMappingURL=safeStorage.mjs.map